// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/payment/v1/responses.proto (package gportal.api.payment.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { Addon, CheckoutBillingAddress, CheckoutLineItem, CheckoutStatus, OrderLocation, PaymentSourceType, Units, UnitType } from "./order_pb.js";
import { Money } from "../../../type/v1/money_pb.js";
import { PaginationResponse } from "../../../type/v1/pagination_pb.js";

/**
 * Which instrument the server used to take the money back. Reported because
 * the three have materially different finance consequences and a supporter
 * looking at a refund needs to know which one happened.
 *
 * @generated from enum gportal.api.payment.v1.ReversalMethod
 */
export enum ReversalMethod {
  /**
   * @generated from enum value: REVERSAL_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The excess payment was still unapplied and was deleted outright — the
   * cleanest outcome, it leaves no trace to reconcile.
   *
   * @generated from enum value: REVERSAL_METHOD_PAYMENT_DELETED = 1;
   */
  PAYMENT_DELETED = 1,

  /**
   * The excess had already been consumed by an invoice, so a credit note was
   * issued against it.
   *
   * @generated from enum value: REVERSAL_METHOD_CREDIT_NOTE = 2;
   */
  CREDIT_NOTE = 2,

  /**
   * Neither was possible and the balance did not cover the reversal, so an
   * open invoice was raised for the clawed-back amount. Only reachable for
   * REVERSAL_REASON_CHARGEBACK, which must always succeed.
   *
   * @generated from enum value: REVERSAL_METHOD_CLAWBACK_INVOICE = 3;
   */
  CLAWBACK_INVOICE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ReversalMethod)
proto3.util.setEnumType(ReversalMethod, "gportal.api.payment.v1.ReversalMethod", [
  { no: 0, name: "REVERSAL_METHOD_UNSPECIFIED" },
  { no: 1, name: "REVERSAL_METHOD_PAYMENT_DELETED" },
  { no: 2, name: "REVERSAL_METHOD_CREDIT_NOTE" },
  { no: 3, name: "REVERSAL_METHOD_CLAWBACK_INVOICE" },
]);

/**
 * Outcome of a MigrateAccountBalance call. An enum rather than a string
 * because the batch runner drives retry and pacing off it: FAILED_NEEDS_RETRY
 * is re-queued, every SKIPPED_ value is held back for a human, and the three
 * success values are counted separately so a batch that is mostly RESUMED is
 * visibly not the same as one that is mostly MIGRATED.
 *
 * @generated from enum gportal.api.payment.v1.MigrationStatus
 */
export enum MigrationStatus {
  /**
   * @generated from enum value: MIGRATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Balance moved and the flag set by this call.
   *
   * @generated from enum value: MIGRATION_STATUS_MIGRATED = 1;
   */
  MIGRATED = 1,

  /**
   * Flag already set and the matching applied ledger row found — nothing to
   * do. The response still reports what was moved originally.
   *
   * @generated from enum value: MIGRATION_STATUS_ALREADY_MIGRATED = 2;
   */
  ALREADY_MIGRATED = 2,

  /**
   * Flag already set but no applied row: a previous attempt died between the
   * Webinterface commit and the Chargebee call. This call finished it.
   *
   * @generated from enum value: MIGRATION_STATUS_RESUMED = 3;
   */
  RESUMED = 3,

  /**
   * The customer holds a balance in a currency their Chargebee business entity
   * may not bill. Recording it would create money that can never be spent,
   * because a charge is invoiced in the balance's own currency.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_UNSUPPORTED_CURRENCY = 4;
   */
  SKIPPED_UNSUPPORTED_CURRENCY = 4,

  /**
   * The ledger sums to a negative balance. Chargebee has no representation for
   * it as an excess payment, so it needs a human.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_NEGATIVE_BALANCE = 5;
   */
  SKIPPED_NEGATIVE_BALANCE = 5,

  /**
   * The customer holds positive balances in more than one currency. The
   * Webinterface's own exchange path converts only the newest currency, so
   * there is no safe automatic remedy.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_MULTI_CURRENCY = 6;
   */
  SKIPPED_MULTI_CURRENCY = 6,

  /**
   * The customer has a legacy stored payment method but no Chargebee payment
   * source, so nothing downstream could collect against the migrated balance.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_NO_CHARGEBEE_PAYMENT_SOURCE = 7;
   */
  SKIPPED_NO_CHARGEBEE_PAYMENT_SOURCE = 7,

  /**
   * `SUM(amount)` and the newest row's `balance_after` disagree for a
   * currency. Migrating either number would bake the discrepancy in
   * permanently, so the ledger is repaired first.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_LEDGER_INCONSISTENT = 8;
   */
  SKIPPED_LEDGER_INCONSISTENT = 8,

  /**
   * A transport or provider failure. The idempotency row is left pending and
   * the call is safe to repeat.
   *
   * @generated from enum value: MIGRATION_STATUS_FAILED_NEEDS_RETRY = 9;
   */
  FAILED_NEEDS_RETRY = 9,

  /**
   * The customer carries the BALANCE_MIGRATION_EXCLUDED flag (e.g. B2B).
   * Their balance stays in the Webinterface and the flag is never set.
   *
   * @generated from enum value: MIGRATION_STATUS_SKIPPED_EXCLUDED = 10;
   */
  SKIPPED_EXCLUDED = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(MigrationStatus)
proto3.util.setEnumType(MigrationStatus, "gportal.api.payment.v1.MigrationStatus", [
  { no: 0, name: "MIGRATION_STATUS_UNSPECIFIED" },
  { no: 1, name: "MIGRATION_STATUS_MIGRATED" },
  { no: 2, name: "MIGRATION_STATUS_ALREADY_MIGRATED" },
  { no: 3, name: "MIGRATION_STATUS_RESUMED" },
  { no: 4, name: "MIGRATION_STATUS_SKIPPED_UNSUPPORTED_CURRENCY" },
  { no: 5, name: "MIGRATION_STATUS_SKIPPED_NEGATIVE_BALANCE" },
  { no: 6, name: "MIGRATION_STATUS_SKIPPED_MULTI_CURRENCY" },
  { no: 7, name: "MIGRATION_STATUS_SKIPPED_NO_CHARGEBEE_PAYMENT_SOURCE" },
  { no: 8, name: "MIGRATION_STATUS_SKIPPED_LEDGER_INCONSISTENT" },
  { no: 9, name: "MIGRATION_STATUS_FAILED_NEEDS_RETRY" },
  { no: 10, name: "MIGRATION_STATUS_SKIPPED_EXCLUDED" },
]);

/**
 * The Webinterface ledger's own discriminator, as the `payment_transactions.type`
 * column declares it — every member of that MySQL enum, not a subset. A value the
 * column allows but this enum omits would arrive as UNSPECIFIED and render as a
 * typeless row, so the two move together.
 *
 * UNSPECIFIED covers three real cases and is not an error: the untyped rows a currency
 * switch writes on purpose, the column's own `unknown` member, and a source whose
 * vocabulary has no equivalent here.
 *
 * @generated from enum gportal.api.payment.v1.LedgerTransactionType
 */
export enum LedgerTransactionType {
  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_PAYMENT = 1;
   */
  PAYMENT = 1,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_REVENUE = 2;
   */
  REVENUE = 2,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_REFUND = 3;
   */
  REFUND = 3,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_CREDIT = 4;
   */
  CREDIT = 4,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_CORRECTION = 5;
   */
  CORRECTION = 5,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_TRANSFER = 6;
   */
  TRANSFER = 6,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_BOOST_INTERNAL = 7;
   */
  BOOST_INTERNAL = 7,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_BOOST_PARTNER = 8;
   */
  BOOST_PARTNER = 8,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_WRITE_OFF = 9;
   */
  WRITE_OFF = 9,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_CHARGEBACK = 10;
   */
  CHARGEBACK = 10,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_GIVEAWAY = 11;
   */
  GIVEAWAY = 11,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_SERVICE_INTERNAL = 12;
   */
  SERVICE_INTERNAL = 12,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_DONATION = 13;
   */
  DONATION = 13,

  /**
   * @generated from enum value: LEDGER_TRANSACTION_TYPE_EXCHANGE = 14;
   */
  EXCHANGE = 14,
}
// Retrieve enum metadata with: proto3.getEnumType(LedgerTransactionType)
proto3.util.setEnumType(LedgerTransactionType, "gportal.api.payment.v1.LedgerTransactionType", [
  { no: 0, name: "LEDGER_TRANSACTION_TYPE_UNSPECIFIED" },
  { no: 1, name: "LEDGER_TRANSACTION_TYPE_PAYMENT" },
  { no: 2, name: "LEDGER_TRANSACTION_TYPE_REVENUE" },
  { no: 3, name: "LEDGER_TRANSACTION_TYPE_REFUND" },
  { no: 4, name: "LEDGER_TRANSACTION_TYPE_CREDIT" },
  { no: 5, name: "LEDGER_TRANSACTION_TYPE_CORRECTION" },
  { no: 6, name: "LEDGER_TRANSACTION_TYPE_TRANSFER" },
  { no: 7, name: "LEDGER_TRANSACTION_TYPE_BOOST_INTERNAL" },
  { no: 8, name: "LEDGER_TRANSACTION_TYPE_BOOST_PARTNER" },
  { no: 9, name: "LEDGER_TRANSACTION_TYPE_WRITE_OFF" },
  { no: 10, name: "LEDGER_TRANSACTION_TYPE_CHARGEBACK" },
  { no: 11, name: "LEDGER_TRANSACTION_TYPE_GIVEAWAY" },
  { no: 12, name: "LEDGER_TRANSACTION_TYPE_SERVICE_INTERNAL" },
  { no: 13, name: "LEDGER_TRANSACTION_TYPE_DONATION" },
  { no: 14, name: "LEDGER_TRANSACTION_TYPE_EXCHANGE" },
]);

/**
 * Which store a payments-page row came from. A list can carry both.
 *
 * @generated from enum gportal.api.payment.v1.PaymentRecordSource
 */
export enum PaymentRecordSource {
  /**
   * @generated from enum value: PAYMENT_RECORD_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_RECORD_SOURCE_LEGACY = 1;
   */
  LEGACY = 1,

  /**
   * @generated from enum value: PAYMENT_RECORD_SOURCE_CHARGEBEE = 2;
   */
  CHARGEBEE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentRecordSource)
proto3.util.setEnumType(PaymentRecordSource, "gportal.api.payment.v1.PaymentRecordSource", [
  { no: 0, name: "PAYMENT_RECORD_SOURCE_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_RECORD_SOURCE_LEGACY" },
  { no: 2, name: "PAYMENT_RECORD_SOURCE_CHARGEBEE" },
]);

/**
 * @generated from message gportal.api.payment.v1.GetManagementUrlResponse
 */
export class GetManagementUrlResponse extends Message<GetManagementUrlResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<GetManagementUrlResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetManagementUrlResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetManagementUrlResponse {
    return new GetManagementUrlResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetManagementUrlResponse {
    return new GetManagementUrlResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetManagementUrlResponse {
    return new GetManagementUrlResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetManagementUrlResponse | PlainMessage<GetManagementUrlResponse> | undefined, b: GetManagementUrlResponse | PlainMessage<GetManagementUrlResponse> | undefined): boolean {
    return proto3.util.equals(GetManagementUrlResponse, a, b);
  }
}

/**
 * Progressive disclosure response for order configuration.
 * Fields are populated based on what was provided in the request.
 *
 * @generated from message gportal.api.payment.v1.GetOrderInformationResponse
 */
export class GetOrderInformationResponse extends Message<GetOrderInformationResponse> {
  /**
   * Whether coupon codes can be applied
   *
   * @generated from field: bool coupons_available = 1;
   */
  couponsAvailable = false;

  /**
   * Returned when location + duration selected
   *
   * @generated from field: optional gportal.api.payment.v1.Units units = 2;
   */
  units?: Units;

  /**
   * Returned when location selected
   *
   * @generated from field: repeated google.protobuf.Duration durations = 3;
   */
  durations: Duration[] = [];

  /**
   * Always returned (filtered by currency)
   *
   * @generated from field: repeated gportal.api.payment.v1.OrderLocation locations = 4;
   */
  locations: OrderLocation[] = [];

  /**
   * Available addons for this product
   *
   * @generated from field: repeated gportal.api.payment.v1.Addon addons = 5;
   */
  addons: Addon[] = [];

  /**
   * True when all required fields are filled
   *
   * @generated from field: bool complete = 6;
   */
  complete = false;

  constructor(data?: PartialMessage<GetOrderInformationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetOrderInformationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupons_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "units", kind: "message", T: Units, opt: true },
    { no: 3, name: "durations", kind: "message", T: Duration, repeated: true },
    { no: 4, name: "locations", kind: "message", T: OrderLocation, repeated: true },
    { no: 5, name: "addons", kind: "message", T: Addon, repeated: true },
    { no: 6, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderInformationResponse {
    return new GetOrderInformationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderInformationResponse {
    return new GetOrderInformationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderInformationResponse {
    return new GetOrderInformationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderInformationResponse | PlainMessage<GetOrderInformationResponse> | undefined, b: GetOrderInformationResponse | PlainMessage<GetOrderInformationResponse> | undefined): boolean {
    return proto3.util.equals(GetOrderInformationResponse, a, b);
  }
}

/**
 * Per-coupon discount detail returned alongside the aggregate discount.
 *
 * @generated from message gportal.api.payment.v1.AppliedCoupon
 */
export class AppliedCoupon extends Message<AppliedCoupon> {
  /**
   * Coupon code (uppercased)
   *
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * Estimated discount for this coupon in the request currency
   *
   * @generated from field: gportal.type.v1.Money discount_amount = 2;
   */
  discountAmount?: Money;

  constructor(data?: PartialMessage<AppliedCoupon>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AppliedCoupon";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "discount_amount", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AppliedCoupon {
    return new AppliedCoupon().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AppliedCoupon {
    return new AppliedCoupon().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AppliedCoupon {
    return new AppliedCoupon().fromJsonString(jsonString, options);
  }

  static equals(a: AppliedCoupon | PlainMessage<AppliedCoupon> | undefined, b: AppliedCoupon | PlainMessage<AppliedCoupon> | undefined): boolean {
    return proto3.util.equals(AppliedCoupon, a, b);
  }
}

/**
 * Itemized price breakdown for the configured order.
 *
 * @generated from message gportal.api.payment.v1.GetOrderPriceResponse
 */
export class GetOrderPriceResponse extends Message<GetOrderPriceResponse> {
  /**
   * Base price (units * unit_price * duration)
   *
   * @generated from field: gportal.type.v1.Money subtotal = 1;
   */
  subtotal?: Money;

  /**
   * Total addon cost
   *
   * @generated from field: gportal.type.v1.Money addons_total = 2;
   */
  addonsTotal?: Money;

  /**
   * Discount from coupon codes (aggregate, capped)
   *
   * @generated from field: gportal.type.v1.Money discount = 3;
   */
  discount?: Money;

  /**
   * Final price
   *
   * @generated from field: gportal.type.v1.Money total = 4;
   */
  total?: Money;

  /**
   * if currency differs, we show the estimate in customer currency
   *
   * @generated from field: optional gportal.type.v1.Money converted_total = 5;
   */
  convertedTotal?: Money;

  /**
   * Coupon codes that could not be found or applied
   *
   * @generated from field: repeated string invalid_coupons = 100;
   */
  invalidCoupons: string[] = [];

  /**
   * Per-coupon discount details (before aggregate cap)
   *
   * @generated from field: repeated gportal.api.payment.v1.AppliedCoupon applied_coupons = 101;
   */
  appliedCoupons: AppliedCoupon[] = [];

  /**
   * The caller's balance in the order's currency, read from the balance cache
   * rather than from Chargebee. Set only for an authenticated caller whose
   * balance lives in Chargebee (balance-migrated); unset for everyone else,
   * including anonymous callers.
   *
   * @generated from field: optional gportal.api.payment.v1.AccountBalance account_balance = 6;
   */
  accountBalance?: AccountBalance;

  /**
   * How that balance would settle this order. Set together with
   * `account_balance`. A preview from cached data: the charge itself is
   * decided at checkout against Chargebee.
   *
   * @generated from field: optional gportal.api.payment.v1.CreditApplication credit_application = 7;
   */
  creditApplication?: CreditApplication;

  constructor(data?: PartialMessage<GetOrderPriceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetOrderPriceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subtotal", kind: "message", T: Money },
    { no: 2, name: "addons_total", kind: "message", T: Money },
    { no: 3, name: "discount", kind: "message", T: Money },
    { no: 4, name: "total", kind: "message", T: Money },
    { no: 5, name: "converted_total", kind: "message", T: Money, opt: true },
    { no: 100, name: "invalid_coupons", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 101, name: "applied_coupons", kind: "message", T: AppliedCoupon, repeated: true },
    { no: 6, name: "account_balance", kind: "message", T: AccountBalance, opt: true },
    { no: 7, name: "credit_application", kind: "message", T: CreditApplication, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderPriceResponse {
    return new GetOrderPriceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderPriceResponse {
    return new GetOrderPriceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderPriceResponse {
    return new GetOrderPriceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderPriceResponse | PlainMessage<GetOrderPriceResponse> | undefined, b: GetOrderPriceResponse | PlainMessage<GetOrderPriceResponse> | undefined): boolean {
    return proto3.util.equals(GetOrderPriceResponse, a, b);
  }
}

/**
 * How a customer's credits settle one order, in the order Chargebee applies
 * them. Promotional credits are a discount: they come off before tax, so they
 * lower the invoice total. The account balance (excess payments and refundable
 * credits) is a payment: it settles part of that total afterwards. Prices are
 * tax-inclusive, so both are plain subtractions from `total`.
 *
 * @generated from message gportal.api.payment.v1.CreditApplication
 */
export class CreditApplication extends Message<CreditApplication> {
  /**
   * Promotional credits applied to this order: min(promotional credits, total).
   *
   * @generated from field: gportal.type.v1.Money promotional_credits_applied = 1;
   */
  promotionalCreditsApplied?: Money;

  /**
   * The invoice total once promotional credits are applied: total minus
   * `promotional_credits_applied`.
   *
   * @generated from field: gportal.type.v1.Money total_after_credits = 2;
   */
  totalAfterCredits?: Money;

  /**
   * Account balance (excess payments plus refundable credits) applied to the
   * rest: min(available balance, `total_after_credits`).
   *
   * @generated from field: gportal.type.v1.Money balance_applied = 3;
   */
  balanceApplied?: Money;

  /**
   * What is left for a payment method to pay now:
   * `total_after_credits` minus `balance_applied`.
   *
   * @generated from field: gportal.type.v1.Money amount_due = 4;
   */
  amountDue?: Money;

  constructor(data?: PartialMessage<CreditApplication>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreditApplication";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "promotional_credits_applied", kind: "message", T: Money },
    { no: 2, name: "total_after_credits", kind: "message", T: Money },
    { no: 3, name: "balance_applied", kind: "message", T: Money },
    { no: 4, name: "amount_due", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditApplication {
    return new CreditApplication().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditApplication {
    return new CreditApplication().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditApplication {
    return new CreditApplication().fromJsonString(jsonString, options);
  }

  static equals(a: CreditApplication | PlainMessage<CreditApplication> | undefined, b: CreditApplication | PlainMessage<CreditApplication> | undefined): boolean {
    return proto3.util.equals(CreditApplication, a, b);
  }
}

/**
 * Processing status of a Payment Components checkout. Returned by
 * GetCheckoutStatus while the website polls after SubmitCheckout. The
 * final `PROCESSED` transition only fires once the subscription is active
 * in Chargebee AND the downstream provisioning (Gamecloud deploy, Loot
 * Pass activation, etc.) has finished — so the redirect URL is safe to
 * follow.
 *
 * @generated from message gportal.api.payment.v1.GetCheckoutStatusResponse
 */
export class GetCheckoutStatusResponse extends Message<GetCheckoutStatusResponse> {
  /**
   * @generated from field: gportal.api.payment.v1.CheckoutStatus status = 1;
   */
  status = CheckoutStatus.UNSPECIFIED;

  /**
   * Product-specific redirect URL (set when status is PROCESSED)
   *
   * @generated from field: optional string redirect_url = 2;
   */
  redirectUrl?: string;

  constructor(data?: PartialMessage<GetCheckoutStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetCheckoutStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CheckoutStatus) },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCheckoutStatusResponse {
    return new GetCheckoutStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCheckoutStatusResponse {
    return new GetCheckoutStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCheckoutStatusResponse {
    return new GetCheckoutStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCheckoutStatusResponse | PlainMessage<GetCheckoutStatusResponse> | undefined, b: GetCheckoutStatusResponse | PlainMessage<GetCheckoutStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetCheckoutStatusResponse, a, b);
  }
}

/**
 * Resolved prices for a single start configuration entry, in all supported currencies.
 *
 * @generated from message gportal.api.payment.v1.StartConfigurationResult
 */
export class StartConfigurationResult extends Message<StartConfigurationResult> {
  /**
   * Prices in all supported currencies
   *
   * @generated from field: repeated gportal.type.v1.Money prices = 1;
   */
  prices: Money[] = [];

  /**
   * Echo back for correlation
   *
   * @generated from field: int32 units = 2;
   */
  units = 0;

  /**
   * Echo back for correlation
   *
   * @generated from field: int32 duration_days = 3;
   */
  durationDays = 0;

  constructor(data?: PartialMessage<StartConfigurationResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartConfigurationResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prices", kind: "message", T: Money, repeated: true },
    { no: 2, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "duration_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartConfigurationResult {
    return new StartConfigurationResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartConfigurationResult {
    return new StartConfigurationResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartConfigurationResult {
    return new StartConfigurationResult().fromJsonString(jsonString, options);
  }

  static equals(a: StartConfigurationResult | PlainMessage<StartConfigurationResult> | undefined, b: StartConfigurationResult | PlainMessage<StartConfigurationResult> | undefined): boolean {
    return proto3.util.equals(StartConfigurationResult, a, b);
  }
}

/**
 * A location with per-configuration prices in all currencies (Gamecloud plans only).
 *
 * @generated from message gportal.api.payment.v1.StartConfigurationLocation
 */
export class StartConfigurationLocation extends Message<StartConfigurationLocation> {
  /**
   * WI location key (e.g. "EUW", "USM")
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * Datacenter slug (e.g. "fra01")
   *
   * @generated from field: string slug = 2;
   */
  slug = "";

  /**
   * Display name (e.g. "Frankfurt")
   *
   * @generated from field: string city = 3;
   */
  city = "";

  /**
   * Country name
   *
   * @generated from field: string country = 4;
   */
  country = "";

  /**
   * ISO country code (e.g. "DE")
   *
   * @generated from field: string country_code = 5;
   */
  countryCode = "";

  /**
   * Whether location is available
   *
   * @generated from field: bool available = 6;
   */
  available = false;

  /**
   * Per-configuration prices
   *
   * @generated from field: repeated gportal.api.payment.v1.StartConfigurationLocationPrice prices = 7;
   */
  prices: StartConfigurationLocationPrice[] = [];

  constructor(data?: PartialMessage<StartConfigurationLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartConfigurationLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "prices", kind: "message", T: StartConfigurationLocationPrice, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartConfigurationLocation {
    return new StartConfigurationLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartConfigurationLocation {
    return new StartConfigurationLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartConfigurationLocation {
    return new StartConfigurationLocation().fromJsonString(jsonString, options);
  }

  static equals(a: StartConfigurationLocation | PlainMessage<StartConfigurationLocation> | undefined, b: StartConfigurationLocation | PlainMessage<StartConfigurationLocation> | undefined): boolean {
    return proto3.util.equals(StartConfigurationLocation, a, b);
  }
}

/**
 * Prices for one location at one (units, duration) combination.
 *
 * @generated from message gportal.api.payment.v1.StartConfigurationLocationPrice
 */
export class StartConfigurationLocationPrice extends Message<StartConfigurationLocationPrice> {
  /**
   * Number of units
   *
   * @generated from field: int32 units = 1;
   */
  units = 0;

  /**
   * Duration in days
   *
   * @generated from field: int32 duration_days = 2;
   */
  durationDays = 0;

  /**
   * Prices in all supported currencies
   *
   * @generated from field: repeated gportal.type.v1.Money prices = 3;
   */
  prices: Money[] = [];

  constructor(data?: PartialMessage<StartConfigurationLocationPrice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartConfigurationLocationPrice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "units", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "duration_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "prices", kind: "message", T: Money, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartConfigurationLocationPrice {
    return new StartConfigurationLocationPrice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartConfigurationLocationPrice {
    return new StartConfigurationLocationPrice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartConfigurationLocationPrice {
    return new StartConfigurationLocationPrice().fromJsonString(jsonString, options);
  }

  static equals(a: StartConfigurationLocationPrice | PlainMessage<StartConfigurationLocationPrice> | undefined, b: StartConfigurationLocationPrice | PlainMessage<StartConfigurationLocationPrice> | undefined): boolean {
    return proto3.util.equals(StartConfigurationLocationPrice, a, b);
  }
}

/**
 * Response with resolved prices and product metadata for start configurations.
 *
 * @generated from message gportal.api.payment.v1.GetStartConfigurationsResponse
 */
export class GetStartConfigurationsResponse extends Message<GetStartConfigurationsResponse> {
  /**
   * @generated from field: repeated gportal.api.payment.v1.StartConfigurationResult results = 1;
   */
  results: StartConfigurationResult[] = [];

  /**
   * Product metadata (populated for Gamecloud plans from WI product info)
   *
   * Only set if product is a preorder
   *
   * @generated from field: optional google.protobuf.Timestamp preorder_date = 2;
   */
  preorderDate?: Timestamp;

  /**
   * SLOT or GB — from WI cloudUnitType
   *
   * @generated from field: optional gportal.api.payment.v1.UnitType unit_type = 3;
   */
  unitType?: UnitType;

  /**
   * e.g. 0.25 — from WI cloudUnitType.multiplier
   *
   * @generated from field: optional double unit_multiplier = 4;
   */
  unitMultiplier?: number;

  /**
   * Gamecloud locations with per-location pricing (empty for non-Gamecloud plans)
   *
   * @generated from field: repeated gportal.api.payment.v1.StartConfigurationLocation locations = 5;
   */
  locations: StartConfigurationLocation[] = [];

  constructor(data?: PartialMessage<GetStartConfigurationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetStartConfigurationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: StartConfigurationResult, repeated: true },
    { no: 2, name: "preorder_date", kind: "message", T: Timestamp, opt: true },
    { no: 3, name: "unit_type", kind: "enum", T: proto3.getEnumType(UnitType), opt: true },
    { no: 4, name: "unit_multiplier", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "locations", kind: "message", T: StartConfigurationLocation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStartConfigurationsResponse {
    return new GetStartConfigurationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStartConfigurationsResponse {
    return new GetStartConfigurationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStartConfigurationsResponse {
    return new GetStartConfigurationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStartConfigurationsResponse | PlainMessage<GetStartConfigurationsResponse> | undefined, b: GetStartConfigurationsResponse | PlainMessage<GetStartConfigurationsResponse> | undefined): boolean {
    return proto3.util.equals(GetStartConfigurationsResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetLootPassFreeMonthCouponResponse
 */
export class GetLootPassFreeMonthCouponResponse extends Message<GetLootPassFreeMonthCouponResponse> {
  /**
   * @generated from field: string coupon_code = 1;
   */
  couponCode = "";

  /**
   * @generated from field: string item_price_id = 3;
   */
  itemPriceId = "";

  constructor(data?: PartialMessage<GetLootPassFreeMonthCouponResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetLootPassFreeMonthCouponResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "coupon_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLootPassFreeMonthCouponResponse {
    return new GetLootPassFreeMonthCouponResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLootPassFreeMonthCouponResponse {
    return new GetLootPassFreeMonthCouponResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLootPassFreeMonthCouponResponse {
    return new GetLootPassFreeMonthCouponResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLootPassFreeMonthCouponResponse | PlainMessage<GetLootPassFreeMonthCouponResponse> | undefined, b: GetLootPassFreeMonthCouponResponse | PlainMessage<GetLootPassFreeMonthCouponResponse> | undefined): boolean {
    return proto3.util.equals(GetLootPassFreeMonthCouponResponse, a, b);
  }
}

/**
 * Subset of the Chargebee payment_intent resource that the website needs
 * to hand back to chargebee.components.create('payment', { paymentIntent }).
 * Field names mirror the Chargebee REST schema so the website can rebuild
 * the snake_case object chargebee.js expects without an error-prone JSON
 * blob in transit.
 *
 * @generated from message gportal.api.payment.v1.ChargebeePaymentIntent
 */
export class ChargebeePaymentIntent extends Message<ChargebeePaymentIntent> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Lifecycle: "inited" | "in_progress" | "authorized" | "consumed" |
   * "expired". The website only reads it for diagnostics; chargebee.js
   * uses it internally to decide which flow to render.
   *
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: string currency_code = 3;
   */
  currencyCode = "";

  /**
   * Amount in the smallest currency unit (cents for EUR/USD). 0 for
   * setup intents (add-payment-method flow).
   *
   * @generated from field: int64 amount = 4;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string gateway_account_id = 5;
   */
  gatewayAccountId = "";

  /**
   * Unix timestamp when the intent expires.
   *
   * @generated from field: int64 expires_at = 6;
   */
  expiresAt = protoInt64.zero;

  /**
   * @generated from field: string reference_id = 7;
   */
  referenceId = "";

  /**
   * "card", "paypal_express_checkout", "apple_pay", "google_pay", ...
   *
   * @generated from field: string payment_method_type = 8;
   */
  paymentMethodType = "";

  /**
   * @generated from field: string success_url = 9;
   */
  successUrl = "";

  /**
   * @generated from field: string failure_url = 10;
   */
  failureUrl = "";

  /**
   * @generated from field: int64 created_at = 11;
   */
  createdAt = protoInt64.zero;

  /**
   * @generated from field: int64 modified_at = 12;
   */
  modifiedAt = protoInt64.zero;

  /**
   * @generated from field: int64 resource_version = 13;
   */
  resourceVersion = protoInt64.zero;

  /**
   * @generated from field: int64 updated_at = 14;
   */
  updatedAt = protoInt64.zero;

  /**
   * @generated from field: string customer_id = 15;
   */
  customerId = "";

  /**
   * Underlying gateway driving the intent ("stripe", "adyen", ...).
   *
   * @generated from field: string gateway = 16;
   */
  gateway = "";

  /**
   * @generated from field: string business_entity_id = 17;
   */
  businessEntityId = "";

  constructor(data?: PartialMessage<ChargebeePaymentIntent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ChargebeePaymentIntent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "gateway_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "payment_method_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "success_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "failure_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "modified_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "resource_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 15, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "gateway", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "business_entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChargebeePaymentIntent {
    return new ChargebeePaymentIntent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChargebeePaymentIntent {
    return new ChargebeePaymentIntent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChargebeePaymentIntent {
    return new ChargebeePaymentIntent().fromJsonString(jsonString, options);
  }

  static equals(a: ChargebeePaymentIntent | PlainMessage<ChargebeePaymentIntent> | undefined, b: ChargebeePaymentIntent | PlainMessage<ChargebeePaymentIntent> | undefined): boolean {
    return proto3.util.equals(ChargebeePaymentIntent, a, b);
  }
}

/**
 * Card-specific display fields for a saved card payment source.
 *
 * @generated from message gportal.api.payment.v1.SavedCardDetails
 */
export class SavedCardDetails extends Message<SavedCardDetails> {
  /**
   * "visa" / "mastercard" / "american_express" / "discover" / ...
   *
   * @generated from field: string brand = 1;
   */
  brand = "";

  /**
   * @generated from field: string last4 = 2;
   */
  last4 = "";

  /**
   * @generated from field: int32 expiry_month = 3;
   */
  expiryMonth = 0;

  /**
   * @generated from field: int32 expiry_year = 4;
   */
  expiryYear = 0;

  constructor(data?: PartialMessage<SavedCardDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SavedCardDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expiry_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "expiry_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SavedCardDetails {
    return new SavedCardDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SavedCardDetails {
    return new SavedCardDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SavedCardDetails {
    return new SavedCardDetails().fromJsonString(jsonString, options);
  }

  static equals(a: SavedCardDetails | PlainMessage<SavedCardDetails> | undefined, b: SavedCardDetails | PlainMessage<SavedCardDetails> | undefined): boolean {
    return proto3.util.equals(SavedCardDetails, a, b);
  }
}

/**
 * PayPal-specific display fields for a saved paypal_express_checkout source.
 *
 * @generated from message gportal.api.payment.v1.SavedPaypalDetails
 */
export class SavedPaypalDetails extends Message<SavedPaypalDetails> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<SavedPaypalDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SavedPaypalDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SavedPaypalDetails {
    return new SavedPaypalDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SavedPaypalDetails {
    return new SavedPaypalDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SavedPaypalDetails {
    return new SavedPaypalDetails().fromJsonString(jsonString, options);
  }

  static equals(a: SavedPaypalDetails | PlainMessage<SavedPaypalDetails> | undefined, b: SavedPaypalDetails | PlainMessage<SavedPaypalDetails> | undefined): boolean {
    return proto3.util.equals(SavedPaypalDetails, a, b);
  }
}

/**
 * A payment method the customer has previously saved with Chargebee
 * (card / PayPal account / Apple Pay token / ...). Surfaced on the
 * checkout step so returning customers can submit with a saved method
 * instead of entering one fresh via chargebee.components.
 *
 * Chargebee Payment Components doesn't expose saved sources in its UI
 * today (still EAP), so we list them server-side and render a picker on
 * our side; if the user opts to "add new", the chargebee.components form
 * takes over and the payment_intent in the same response is used.
 *
 * @generated from message gportal.api.payment.v1.SavedPaymentMethod
 */
export class SavedPaymentMethod extends Message<SavedPaymentMethod> {
  /**
   * Chargebee payment_source.id — pass this to SubmitCheckout via
   * existing_payment_source_id when the user picks a saved method.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Chargebee payment_source.type ("card", "paypal_express_checkout",
   * "apple_pay", "google_pay", ...). Plain string so new chargebee
   * method types render with a generic label even if their `details`
   * variant isn't modeled below yet.
   *
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * Unix timestamp when the method was added to Chargebee — used by the
   * website to preselect the most recently saved method.
   *
   * @generated from field: int64 created_at = 3;
   */
  createdAt = protoInt64.zero;

  /**
   * Whether this is the customer's primary_payment_source_id in Chargebee —
   * the source renewals are collected from.
   *
   * @generated from field: bool is_primary = 4;
   */
  isPrimary = false;

  /**
   * Whether this is the customer's backup_payment_source_id in Chargebee —
   * the source Chargebee falls back to when the primary cannot be charged.
   *
   * @generated from field: bool is_backup = 5;
   */
  isBackup = false;

  /**
   * Type-specific display fields. Exactly one variant is set per type
   * (or none, for chargebee method types we haven't modeled here yet —
   * clients should fall back to `type` as the display label in that
   * case). Add new variants as new method types need richer display.
   *
   * @generated from oneof gportal.api.payment.v1.SavedPaymentMethod.details
   */
  details: {
    /**
     * @generated from field: gportal.api.payment.v1.SavedCardDetails card = 10;
     */
    value: SavedCardDetails;
    case: "card";
  } | {
    /**
     * @generated from field: gportal.api.payment.v1.SavedPaypalDetails paypal = 11;
     */
    value: SavedPaypalDetails;
    case: "paypal";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SavedPaymentMethod>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SavedPaymentMethod";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_backup", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "card", kind: "message", T: SavedCardDetails, oneof: "details" },
    { no: 11, name: "paypal", kind: "message", T: SavedPaypalDetails, oneof: "details" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SavedPaymentMethod {
    return new SavedPaymentMethod().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SavedPaymentMethod {
    return new SavedPaymentMethod().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SavedPaymentMethod {
    return new SavedPaymentMethod().fromJsonString(jsonString, options);
  }

  static equals(a: SavedPaymentMethod | PlainMessage<SavedPaymentMethod> | undefined, b: SavedPaymentMethod | PlainMessage<SavedPaymentMethod> | undefined): boolean {
    return proto3.util.equals(SavedPaymentMethod, a, b);
  }
}

/**
 * Chargebee hosted checkout redirect URL. Returned by the legacy
 * CreateCheckoutURL flow — gated behind the `payment-components` feature
 * flag being OFF.
 *
 * @generated from message gportal.api.payment.v1.CreateCheckoutURLResponse
 */
export class CreateCheckoutURLResponse extends Message<CreateCheckoutURLResponse> {
  /**
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl = "";

  /**
   * Chargebee hosted page ID — passed to GetCheckoutStatus
   * (via the hosted_page_id key) so the result page can poll the same
   * post-checkout reconciliation pipeline as the new flow.
   *
   * @generated from field: string hosted_page_id = 2;
   */
  hostedPageId = "";

  /**
   * Coupon codes supplied in the request that were not applied to the checkout
   * (e.g. expired, unknown, or duplicate). Empty when every code was applied.
   * The frontend can surface these so the customer knows which codes were dropped.
   *
   * @generated from field: repeated string dropped_coupons = 3;
   */
  droppedCoupons: string[] = [];

  constructor(data?: PartialMessage<CreateCheckoutURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateCheckoutURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "checkout_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hosted_page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dropped_coupons", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCheckoutURLResponse {
    return new CreateCheckoutURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCheckoutURLResponse {
    return new CreateCheckoutURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCheckoutURLResponse {
    return new CreateCheckoutURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCheckoutURLResponse | PlainMessage<CreateCheckoutURLResponse> | undefined, b: CreateCheckoutURLResponse | PlainMessage<CreateCheckoutURLResponse> | undefined): boolean {
    return proto3.util.equals(CreateCheckoutURLResponse, a, b);
  }
}

/**
 * Result of attaching a payment source via the legacy SetupPaymentMethod
 * flow. Returned shape is intentionally narrower than the new flow's
 * SubmitPaymentMethodSetupResponse (no created_at, no PayPal variant)
 * because nothing on the website ever consumed those fields on the
 * legacy path.
 *
 * @generated from message gportal.api.payment.v1.SetupPaymentMethodResponse
 */
export class SetupPaymentMethodResponse extends Message<SetupPaymentMethodResponse> {
  /**
   * Chargebee payment source ID (e.g. "pm_AzZlkBSpc4lF7Plu").
   *
   * @generated from field: string payment_source_id = 1;
   */
  paymentSourceId = "";

  /**
   * Payment source type. Returned even when no typed `details` are
   * populated, so callers can render a generic label for non-card
   * sources.
   *
   * @generated from field: gportal.api.payment.v1.PaymentSourceType type = 2;
   */
  type = PaymentSourceType.UNSPECIFIED;

  /**
   * @generated from oneof gportal.api.payment.v1.SetupPaymentMethodResponse.details
   */
  details: {
    /**
     * @generated from field: gportal.api.payment.v1.SetupPaymentMethodCardDetails card = 10;
     */
    value: SetupPaymentMethodCardDetails;
    case: "card";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SetupPaymentMethodResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SetupPaymentMethodResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(PaymentSourceType) },
    { no: 10, name: "card", kind: "message", T: SetupPaymentMethodCardDetails, oneof: "details" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupPaymentMethodResponse {
    return new SetupPaymentMethodResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupPaymentMethodResponse {
    return new SetupPaymentMethodResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupPaymentMethodResponse {
    return new SetupPaymentMethodResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetupPaymentMethodResponse | PlainMessage<SetupPaymentMethodResponse> | undefined, b: SetupPaymentMethodResponse | PlainMessage<SetupPaymentMethodResponse> | undefined): boolean {
    return proto3.util.equals(SetupPaymentMethodResponse, a, b);
  }
}

/**
 * Card metadata pulled from Chargebee for display ("Visa •••• 4242, exp 12/27").
 *
 * @generated from message gportal.api.payment.v1.SetupPaymentMethodCardDetails
 */
export class SetupPaymentMethodCardDetails extends Message<SetupPaymentMethodCardDetails> {
  /**
   * Card brand from Chargebee enum (e.g. "visa", "mastercard", "american_express").
   *
   * @generated from field: string brand = 1;
   */
  brand = "";

  /**
   * Last four digits of the card.
   *
   * @generated from field: string last4 = 2;
   */
  last4 = "";

  /**
   * Expiry month, 1-12.
   *
   * @generated from field: int32 expiry_month = 3;
   */
  expiryMonth = 0;

  /**
   * Expiry year, 4-digit.
   *
   * @generated from field: int32 expiry_year = 4;
   */
  expiryYear = 0;

  constructor(data?: PartialMessage<SetupPaymentMethodCardDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SetupPaymentMethodCardDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expiry_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "expiry_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetupPaymentMethodCardDetails {
    return new SetupPaymentMethodCardDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetupPaymentMethodCardDetails {
    return new SetupPaymentMethodCardDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetupPaymentMethodCardDetails {
    return new SetupPaymentMethodCardDetails().fromJsonString(jsonString, options);
  }

  static equals(a: SetupPaymentMethodCardDetails | PlainMessage<SetupPaymentMethodCardDetails> | undefined, b: SetupPaymentMethodCardDetails | PlainMessage<SetupPaymentMethodCardDetails> | undefined): boolean {
    return proto3.util.equals(SetupPaymentMethodCardDetails, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.CreateCheckoutPaymentIntentResponse
 */
export class CreateCheckoutPaymentIntentResponse extends Message<CreateCheckoutPaymentIntentResponse> {
  /**
   * Newly created Chargebee payment_intent. The website rebuilds the
   * snake_case shape chargebee.js expects and passes it to
   * chargebee.components.create('payment', { paymentIntent }, callbacks).
   * Only used when the customer picks "Add new payment method" — for
   * saved-method submissions the intent is created but never consumed
   * (it expires server-side after ~30 minutes, no harm).
   *
   * @generated from field: gportal.api.payment.v1.ChargebeePaymentIntent payment_intent = 1;
   */
  paymentIntent?: ChargebeePaymentIntent;

  /**
   * Payment methods the customer has previously saved, ordered most
   * recent first. Empty for new customers — in that case the website
   * mounts the chargebee.components form immediately.
   *
   * @generated from field: repeated gportal.api.payment.v1.SavedPaymentMethod saved_payment_methods = 2;
   */
  savedPaymentMethods: SavedPaymentMethod[] = [];

  /**
   * Not populated. The payment component needs no cart for any allowed method
   * (Klarna via Stripe takes its recurring interval from
   * `context.additionalData.subscription` instead), so the API sends none.
   *
   * @generated from field: repeated gportal.api.payment.v1.CheckoutLineItem line_items = 3 [deprecated = true];
   * @deprecated
   */
  lineItems: CheckoutLineItem[] = [];

  /**
   * Billing details prefilled into the chargebee.components
   * `context.billingAddress` for the alternative methods (Klarna, Alipay, ...)
   * that render an address form.
   * Only the fields we hold are populated; nil when there's no customer.
   *
   * @generated from field: gportal.api.payment.v1.CheckoutBillingAddress billing_address = 4;
   */
  billingAddress?: CheckoutBillingAddress;

  /**
   * The order total before credits, so the balance fields below can be
   * compared against it without the website re-deriving the amount. The
   * payment_intent is authorized for what is due after the customer's credits,
   * which Chargebee applies before it captures (all of the total when the
   * credits cover it).
   *
   * @generated from field: gportal.type.v1.Money total = 5;
   */
  total?: Money;

  /**
   * The customer's spendable Chargebee balance in the checkout currency, read
   * fresh rather than from cache. Populated only for migrated customers, so a
   * client cannot offer balance payment for anyone else.
   *
   * @generated from field: gportal.type.v1.Money available_balance = 6;
   */
  availableBalance?: Money;

  /**
   * Whether the customer's credits cover `total` in full: the promotional
   * credit Chargebee takes off the invoice first, then `available_balance` for
   * the rest. The server decides this — a client that computes it from the
   * Money values above would disagree with the submit-time re-check, and does
   * not see the promotional credit.
   *
   * @generated from field: bool balance_covers_total = 7;
   */
  balanceCoversTotal = false;

  constructor(data?: PartialMessage<CreateCheckoutPaymentIntentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateCheckoutPaymentIntentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_intent", kind: "message", T: ChargebeePaymentIntent },
    { no: 2, name: "saved_payment_methods", kind: "message", T: SavedPaymentMethod, repeated: true },
    { no: 3, name: "line_items", kind: "message", T: CheckoutLineItem, repeated: true },
    { no: 4, name: "billing_address", kind: "message", T: CheckoutBillingAddress },
    { no: 5, name: "total", kind: "message", T: Money },
    { no: 6, name: "available_balance", kind: "message", T: Money },
    { no: 7, name: "balance_covers_total", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCheckoutPaymentIntentResponse {
    return new CreateCheckoutPaymentIntentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCheckoutPaymentIntentResponse {
    return new CreateCheckoutPaymentIntentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCheckoutPaymentIntentResponse {
    return new CreateCheckoutPaymentIntentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCheckoutPaymentIntentResponse | PlainMessage<CreateCheckoutPaymentIntentResponse> | undefined, b: CreateCheckoutPaymentIntentResponse | PlainMessage<CreateCheckoutPaymentIntentResponse> | undefined): boolean {
    return proto3.util.equals(CreateCheckoutPaymentIntentResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.CreateSetupPaymentIntentResponse
 */
export class CreateSetupPaymentIntentResponse extends Message<CreateSetupPaymentIntentResponse> {
  /**
   * Newly created Chargebee payment_intent (amount = 0). Same shape and
   * usage as CreateCheckoutPaymentIntentResponse.payment_intent.
   *
   * @generated from field: gportal.api.payment.v1.ChargebeePaymentIntent payment_intent = 1;
   */
  paymentIntent?: ChargebeePaymentIntent;

  constructor(data?: PartialMessage<CreateSetupPaymentIntentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.CreateSetupPaymentIntentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_intent", kind: "message", T: ChargebeePaymentIntent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSetupPaymentIntentResponse {
    return new CreateSetupPaymentIntentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSetupPaymentIntentResponse {
    return new CreateSetupPaymentIntentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSetupPaymentIntentResponse {
    return new CreateSetupPaymentIntentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSetupPaymentIntentResponse | PlainMessage<CreateSetupPaymentIntentResponse> | undefined, b: CreateSetupPaymentIntentResponse | PlainMessage<CreateSetupPaymentIntentResponse> | undefined): boolean {
    return proto3.util.equals(CreateSetupPaymentIntentResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.SubmitCheckoutResponse
 */
export class SubmitCheckoutResponse extends Message<SubmitCheckoutResponse> {
  /**
   * Chargebee subscription ID that was just created. The website holds on
   * to this for diagnostics, but the post-checkout redirect URL is
   * resolved by GetCheckoutStatus (which waits for the webhook +
   * provisioning chain) — not from this response.
   *
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId = "";

  constructor(data?: PartialMessage<SubmitCheckoutResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SubmitCheckoutResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitCheckoutResponse {
    return new SubmitCheckoutResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitCheckoutResponse {
    return new SubmitCheckoutResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitCheckoutResponse {
    return new SubmitCheckoutResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitCheckoutResponse | PlainMessage<SubmitCheckoutResponse> | undefined, b: SubmitCheckoutResponse | PlainMessage<SubmitCheckoutResponse> | undefined): boolean {
    return proto3.util.equals(SubmitCheckoutResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.SubmitPaymentMethodSetupResponse
 */
export class SubmitPaymentMethodSetupResponse extends Message<SubmitPaymentMethodSetupResponse> {
  /**
   * Chargebee payment_source.id of the attached method.
   *
   * @generated from field: string payment_source_id = 1;
   */
  paymentSourceId = "";

  /**
   * Type as Chargebee returns it ("card", "paypal_express_checkout", ...).
   * Plain string — keep it loose so new payment methods don't require a
   * proto change to surface.
   *
   * @generated from field: string type = 2;
   */
  type = "";

  constructor(data?: PartialMessage<SubmitPaymentMethodSetupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.SubmitPaymentMethodSetupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitPaymentMethodSetupResponse {
    return new SubmitPaymentMethodSetupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitPaymentMethodSetupResponse {
    return new SubmitPaymentMethodSetupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitPaymentMethodSetupResponse {
    return new SubmitPaymentMethodSetupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitPaymentMethodSetupResponse | PlainMessage<SubmitPaymentMethodSetupResponse> | undefined, b: SubmitPaymentMethodSetupResponse | PlainMessage<SubmitPaymentMethodSetupResponse> | undefined): boolean {
    return proto3.util.equals(SubmitPaymentMethodSetupResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.ListSavedPaymentMethodsResponse
 */
export class ListSavedPaymentMethodsResponse extends Message<ListSavedPaymentMethodsResponse> {
  /**
   * Valid, non-deleted sources only; the primary first, then most recent
   * first. Empty when the customer has none.
   *
   * @generated from field: repeated gportal.api.payment.v1.SavedPaymentMethod saved_payment_methods = 1;
   */
  savedPaymentMethods: SavedPaymentMethod[] = [];

  constructor(data?: PartialMessage<ListSavedPaymentMethodsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListSavedPaymentMethodsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "saved_payment_methods", kind: "message", T: SavedPaymentMethod, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSavedPaymentMethodsResponse {
    return new ListSavedPaymentMethodsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSavedPaymentMethodsResponse {
    return new ListSavedPaymentMethodsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSavedPaymentMethodsResponse {
    return new ListSavedPaymentMethodsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSavedPaymentMethodsResponse | PlainMessage<ListSavedPaymentMethodsResponse> | undefined, b: ListSavedPaymentMethodsResponse | PlainMessage<ListSavedPaymentMethodsResponse> | undefined): boolean {
    return proto3.util.equals(ListSavedPaymentMethodsResponse, a, b);
  }
}

/**
 * Result of recording an offline payment on Chargebee.
 *
 * @generated from message gportal.api.payment.v1.RecordOfflinePaymentResponse
 */
export class RecordOfflinePaymentResponse extends Message<RecordOfflinePaymentResponse> {
  /**
   * Chargebee transaction id (txn_...) created by RecordExcessPayment. When an
   * existing transaction with the same ReferenceNumber is found, its id is
   * returned instead of recording a new one.
   *
   * @generated from field: string chargebee_transaction_id = 1;
   */
  chargebeeTransactionId = "";

  constructor(data?: PartialMessage<RecordOfflinePaymentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.RecordOfflinePaymentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chargebee_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordOfflinePaymentResponse {
    return new RecordOfflinePaymentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordOfflinePaymentResponse {
    return new RecordOfflinePaymentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordOfflinePaymentResponse {
    return new RecordOfflinePaymentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RecordOfflinePaymentResponse | PlainMessage<RecordOfflinePaymentResponse> | undefined, b: RecordOfflinePaymentResponse | PlainMessage<RecordOfflinePaymentResponse> | undefined): boolean {
    return proto3.util.equals(RecordOfflinePaymentResponse, a, b);
  }
}

/**
 * Result of crediting the Chargebee account balance.
 *
 * @generated from message gportal.api.payment.v1.AddAccountBalanceResponse
 */
export class AddAccountBalanceResponse extends Message<AddAccountBalanceResponse> {
  /**
   * Chargebee transaction id (txn_...) of the recorded excess payment. When a
   * transaction with the same reference already exists, its id is returned.
   *
   * @generated from field: string chargebee_transaction_id = 1;
   */
  chargebeeTransactionId = "";

  /**
   * True when the reference was already applied and no new money was booked.
   * The response is otherwise identical to the first call's, which is what
   * makes a retry safe.
   *
   * @generated from field: bool already_applied = 2;
   */
  alreadyApplied = false;

  /**
   * Invoices the new excess was applied to, when debt-first application is
   * enabled. Empty means the whole amount stayed as excess.
   *
   * @generated from field: repeated string applied_invoice_ids = 3;
   */
  appliedInvoiceIds: string[] = [];

  constructor(data?: PartialMessage<AddAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AddAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chargebee_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "already_applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "applied_invoice_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddAccountBalanceResponse {
    return new AddAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddAccountBalanceResponse {
    return new AddAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddAccountBalanceResponse {
    return new AddAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddAccountBalanceResponse | PlainMessage<AddAccountBalanceResponse> | undefined, b: AddAccountBalanceResponse | PlainMessage<AddAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(AddAccountBalanceResponse, a, b);
  }
}

/**
 * Result of spending part of the Chargebee account balance.
 *
 * @generated from message gportal.api.payment.v1.ConsumeAccountBalanceResponse
 */
export class ConsumeAccountBalanceResponse extends Message<ConsumeAccountBalanceResponse> {
  /**
   * The one-time invoice raised for the charge and settled from the balance.
   *
   * @generated from field: string chargebee_invoice_id = 1;
   */
  chargebeeInvoiceId = "";

  /**
   * Payments Chargebee linked to that invoice out of the balance buckets.
   *
   * @generated from field: repeated string chargebee_transaction_ids = 2;
   */
  chargebeeTransactionIds: string[] = [];

  /**
   * @generated from field: bool already_applied = 3;
   */
  alreadyApplied = false;

  /**
   * Balance left after the charge, re-read from Chargebee rather than
   * computed. Lets the Webinterface refresh its own display in the same round
   * trip that spent the money.
   *
   * @generated from field: gportal.type.v1.Money remaining_balance = 4;
   */
  remainingBalance?: Money;

  /**
   * How the charge was actually settled. The two always sum to the invoice
   * total, and `amount_from_payment_method` is non-zero only for a
   * COLLECTION_MODE_BALANCE_THEN_PAYMENT_METHOD call whose balance fell short.
   *
   * The Webinterface books its offsetting ledger row from the total either way
   * — the money reached us through Chargebee and was spent in the same breath —
   * so this split is not an accounting input. It exists because nothing else on
   * our side records *how* a migrated customer's renewal was paid, and a
   * supporter answering "why was my card charged, I have credit" has otherwise
   * only the Chargebee invoice to go on.
   *
   * Both are unset on an `already_applied` replay, for the same reason
   * `remaining_balance` is: this attempt collected nothing, the first one did,
   * and a confident zero here would read as "the card paid nothing" rather than
   * as "ask the first attempt".
   *
   * @generated from field: gportal.type.v1.Money amount_from_balance = 5;
   */
  amountFromBalance?: Money;

  /**
   * @generated from field: gportal.type.v1.Money amount_from_payment_method = 6;
   */
  amountFromPaymentMethod?: Money;

  constructor(data?: PartialMessage<ConsumeAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ConsumeAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chargebee_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "chargebee_transaction_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "already_applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "remaining_balance", kind: "message", T: Money },
    { no: 5, name: "amount_from_balance", kind: "message", T: Money },
    { no: 6, name: "amount_from_payment_method", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConsumeAccountBalanceResponse {
    return new ConsumeAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConsumeAccountBalanceResponse {
    return new ConsumeAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConsumeAccountBalanceResponse {
    return new ConsumeAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConsumeAccountBalanceResponse | PlainMessage<ConsumeAccountBalanceResponse> | undefined, b: ConsumeAccountBalanceResponse | PlainMessage<ConsumeAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(ConsumeAccountBalanceResponse, a, b);
  }
}

/**
 * A customer's Chargebee balance in one currency. Chargebee keeps the money in
 * several buckets and only `Customer.Balances[]` is currency-tagged, so this
 * message is per-currency by construction and a customer may have more than
 * one.
 *
 * @generated from message gportal.api.payment.v1.AccountBalance
 */
export class AccountBalance extends Message<AccountBalance> {
  /**
   * ISO 4217 code these buckets are denominated in.
   *
   * @generated from field: string currency_code = 1;
   */
  currencyCode = "";

  /**
   * Unapplied excess payments — top-ups and the migrated balance.
   *
   * @generated from field: gportal.type.v1.Money excess_payments = 2;
   */
  excessPayments?: Money;

  /**
   * Refundable credits. This is the refundability of the *source*, not a
   * finance construct: a SEPA-backed offline payment is refundable, a
   * PaysafeCard one is not. It is the customer's money either way, so it is
   * spendable and it counts towards `available_balance`.
   *
   * @generated from field: gportal.type.v1.Money refundable_credits = 3;
   */
  refundableCredits?: Money;

  /**
   * Promotional credits — the discount instrument, NOT part of the account
   * balance and deliberately excluded from `available_balance`. Reported here
   * because the monthly partner payout caps itself against this number.
   *
   * @generated from field: gportal.type.v1.Money promotional_credits = 4;
   */
  promotionalCredits?: Money;

  /**
   * Sum of `amount_due` over the customer's open invoices. Chargebee's
   * customer object does not carry it, so it is fetched and cached separately.
   *
   * @generated from field: gportal.type.v1.Money outstanding_due = 5;
   */
  outstandingDue?: Money;

  /**
   * What a charge can actually collect right now: excess payments plus
   * refundable credits. This is the number the legacy read gates compare a
   * price against.
   *
   * @generated from field: gportal.type.v1.Money available_balance = 6;
   */
  availableBalance?: Money;

  /**
   * What the customer is shown: `available_balance` plus `promotional_credits`,
   * minus `outstanding_due`. No gate reads it; `available_balance` is what a
   * charge can collect.
   * Can be negative — an uncoverable chargeback is represented as debt here
   * rather than as an unreconciled Webinterface row.
   *
   * @generated from field: gportal.type.v1.Money net_balance = 7;
   */
  netBalance?: Money;

  constructor(data?: PartialMessage<AccountBalance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AccountBalance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "excess_payments", kind: "message", T: Money },
    { no: 3, name: "refundable_credits", kind: "message", T: Money },
    { no: 4, name: "promotional_credits", kind: "message", T: Money },
    { no: 5, name: "outstanding_due", kind: "message", T: Money },
    { no: 6, name: "available_balance", kind: "message", T: Money },
    { no: 7, name: "net_balance", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountBalance {
    return new AccountBalance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountBalance {
    return new AccountBalance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountBalance {
    return new AccountBalance().fromJsonString(jsonString, options);
  }

  static equals(a: AccountBalance | PlainMessage<AccountBalance> | undefined, b: AccountBalance | PlainMessage<AccountBalance> | undefined): boolean {
    return proto3.util.equals(AccountBalance, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetAccountBalanceResponse
 */
export class GetAccountBalanceResponse extends Message<GetAccountBalanceResponse> {
  /**
   * One entry per currency the customer holds a bucket in, or the single
   * requested currency when the request filtered. A migrated customer with no
   * money holds no buckets at all, so an empty list is a normal answer and not
   * an error.
   *
   * @generated from field: repeated gportal.api.payment.v1.AccountBalance balances = 1;
   */
  balances: AccountBalance[] = [];

  /**
   * Whether `customer_details.balance_migrated_at` is set, read authoritatively
   * rather than from the caller's own request-scoped copy. A caller that
   * believes it is migrated and sees false here has found a flag divergence,
   * which is exactly what the reconciliation sweep looks for.
   *
   * @generated from field: bool balance_migrated = 2;
   */
  balanceMigrated = false;

  /**
   * When the flag was set. Unset while `balance_migrated` is false.
   *
   * @generated from field: google.protobuf.Timestamp balance_migrated_at = 3;
   */
  balanceMigratedAt?: Timestamp;

  constructor(data?: PartialMessage<GetAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balances", kind: "message", T: AccountBalance, repeated: true },
    { no: 2, name: "balance_migrated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "balance_migrated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBalanceResponse {
    return new GetAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBalanceResponse {
    return new GetAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBalanceResponse {
    return new GetAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBalanceResponse | PlainMessage<GetAccountBalanceResponse> | undefined, b: GetAccountBalanceResponse | PlainMessage<GetAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(GetAccountBalanceResponse, a, b);
  }
}

/**
 * Result of granting promotional credits.
 *
 * @generated from message gportal.api.payment.v1.AddPromotionalCreditsResponse
 */
export class AddPromotionalCreditsResponse extends Message<AddPromotionalCreditsResponse> {
  /**
   * The customer's promotional credit total after the grant, re-read from
   * Chargebee. The partner payout cap is enforced against this.
   *
   * @generated from field: gportal.type.v1.Money promotional_credits = 1;
   */
  promotionalCredits?: Money;

  /**
   * @generated from field: bool already_applied = 2;
   */
  alreadyApplied = false;

  constructor(data?: PartialMessage<AddPromotionalCreditsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AddPromotionalCreditsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "promotional_credits", kind: "message", T: Money },
    { no: 2, name: "already_applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddPromotionalCreditsResponse {
    return new AddPromotionalCreditsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddPromotionalCreditsResponse {
    return new AddPromotionalCreditsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddPromotionalCreditsResponse {
    return new AddPromotionalCreditsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddPromotionalCreditsResponse | PlainMessage<AddPromotionalCreditsResponse> | undefined, b: AddPromotionalCreditsResponse | PlainMessage<AddPromotionalCreditsResponse> | undefined): boolean {
    return proto3.util.equals(AddPromotionalCreditsResponse, a, b);
  }
}

/**
 * Result of reversing a credit to the account balance.
 *
 * @generated from message gportal.api.payment.v1.ReverseAccountBalanceResponse
 */
export class ReverseAccountBalanceResponse extends Message<ReverseAccountBalanceResponse> {
  /**
   * @generated from field: gportal.api.payment.v1.ReversalMethod method = 1;
   */
  method = ReversalMethod.UNSPECIFIED;

  /**
   * Set for REVERSAL_METHOD_CREDIT_NOTE.
   *
   * @generated from field: string chargebee_credit_note_id = 2;
   */
  chargebeeCreditNoteId = "";

  /**
   * Set for REVERSAL_METHOD_CLAWBACK_INVOICE.
   *
   * @generated from field: string chargebee_invoice_id = 3;
   */
  chargebeeInvoiceId = "";

  /**
   * Set for REVERSAL_METHOD_PAYMENT_DELETED — the transaction that was
   * deleted, kept so the Webinterface row can still name what it reversed.
   *
   * @generated from field: string chargebee_transaction_id = 4;
   */
  chargebeeTransactionId = "";

  /**
   * @generated from field: bool already_applied = 5;
   */
  alreadyApplied = false;

  constructor(data?: PartialMessage<ReverseAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ReverseAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "method", kind: "enum", T: proto3.getEnumType(ReversalMethod) },
    { no: 2, name: "chargebee_credit_note_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "chargebee_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chargebee_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "already_applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReverseAccountBalanceResponse {
    return new ReverseAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReverseAccountBalanceResponse {
    return new ReverseAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReverseAccountBalanceResponse {
    return new ReverseAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReverseAccountBalanceResponse | PlainMessage<ReverseAccountBalanceResponse> | undefined, b: ReverseAccountBalanceResponse | PlainMessage<ReverseAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(ReverseAccountBalanceResponse, a, b);
  }
}

/**
 * Response of UnwindConsumeAccountBalance.
 *
 * @generated from message gportal.api.payment.v1.UnwindConsumeAccountBalanceResponse
 */
export class UnwindConsumeAccountBalanceResponse extends Message<UnwindConsumeAccountBalanceResponse> {
  /**
   * The voided invoice the consume had raised.
   *
   * @generated from field: string chargebee_invoice_id = 1;
   */
  chargebeeInvoiceId = "";

  /**
   * What went back to the balance as excess by this call. Zero when
   * `already_unwound` is set.
   *
   * @generated from field: gportal.type.v1.Money amount_returned = 2;
   */
  amountReturned?: Money;

  /**
   * True when an earlier call already unwound this consume; nothing moved.
   *
   * @generated from field: bool already_unwound = 3;
   */
  alreadyUnwound = false;

  constructor(data?: PartialMessage<UnwindConsumeAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.UnwindConsumeAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chargebee_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount_returned", kind: "message", T: Money },
    { no: 3, name: "already_unwound", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnwindConsumeAccountBalanceResponse {
    return new UnwindConsumeAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnwindConsumeAccountBalanceResponse {
    return new UnwindConsumeAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnwindConsumeAccountBalanceResponse {
    return new UnwindConsumeAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnwindConsumeAccountBalanceResponse | PlainMessage<UnwindConsumeAccountBalanceResponse> | undefined, b: UnwindConsumeAccountBalanceResponse | PlainMessage<UnwindConsumeAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(UnwindConsumeAccountBalanceResponse, a, b);
  }
}

/**
 * What the migration did — or, for a dry run, would do — for one currency.
 *
 * @generated from message gportal.api.payment.v1.MigratedCurrency
 */
export class MigratedCurrency extends Message<MigratedCurrency> {
  /**
   * ISO 4217 code of the Webinterface balance this entry covers.
   *
   * @generated from field: string currency_code = 1;
   */
  currencyCode = "";

  /**
   * Amount moved off the Webinterface ledger onto Chargebee.
   *
   * @generated from field: gportal.type.v1.Money amount_moved = 2;
   */
  amountMoved?: Money;

  /**
   * Chargebee excess in this currency *before* the migration wrote anything.
   * PaysafeCard-transfer and preorder-refund customers already hold excess, so
   * reconciliation has to compare a delta, not a total.
   *
   * @generated from field: gportal.type.v1.Money pre_existing_excess = 3;
   */
  preExistingExcess?: Money;

  /**
   * Chargebee transaction id of the recorded excess payment. Empty on a dry
   * run and on every skip.
   *
   * @generated from field: string chargebee_transaction_id = 4;
   */
  chargebeeTransactionId = "";

  /**
   * `payment_transactions.id` of the zeroing `transfer` row the Webinterface
   * wrote. Preserves finance's equality join between the two ledgers. Zero on
   * a dry run and on every skip.
   *
   * @generated from field: int64 wi_transaction_id = 5;
   */
  wiTransactionId = protoInt64.zero;

  /**
   * True when the post-migration check held: the Chargebee excess grew by
   * exactly `amount_moved` and the Webinterface balance is now zero. False
   * means the money moved but the books disagree — the case the reconciliation
   * sweep exists for. Always false on a dry run, which writes nothing to check.
   *
   * @generated from field: bool reconciled = 6;
   */
  reconciled = false;

  constructor(data?: PartialMessage<MigratedCurrency>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.MigratedCurrency";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount_moved", kind: "message", T: Money },
    { no: 3, name: "pre_existing_excess", kind: "message", T: Money },
    { no: 4, name: "chargebee_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "wi_transaction_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "reconciled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MigratedCurrency {
    return new MigratedCurrency().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MigratedCurrency {
    return new MigratedCurrency().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MigratedCurrency {
    return new MigratedCurrency().fromJsonString(jsonString, options);
  }

  static equals(a: MigratedCurrency | PlainMessage<MigratedCurrency> | undefined, b: MigratedCurrency | PlainMessage<MigratedCurrency> | undefined): boolean {
    return proto3.util.equals(MigratedCurrency, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.MigrateAccountBalanceResponse
 */
export class MigrateAccountBalanceResponse extends Message<MigrateAccountBalanceResponse> {
  /**
   * One entry per currency considered, including the ones that were skipped —
   * a skip with no entry would leave the batch runner unable to say which
   * currency tripped it.
   *
   * @generated from field: repeated gportal.api.payment.v1.MigratedCurrency results = 1;
   */
  results: MigratedCurrency[] = [];

  /**
   * @generated from field: gportal.api.payment.v1.MigrationStatus status = 2;
   */
  status = MigrationStatus.UNSPECIFIED;

  /**
   * Human-readable detail behind `status`. Populated for every skip and every
   * failure; empty on success. Never parsed — `status` is the contract.
   *
   * @generated from field: string reason = 3;
   */
  reason = "";

  /**
   * Echoes the request. When true nothing was written and `status` is what a
   * real run would have returned, so a batch log cannot be misread as a
   * record of money that moved.
   *
   * @generated from field: bool dry_run = 4;
   */
  dryRun = false;

  constructor(data?: PartialMessage<MigrateAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.MigrateAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: MigratedCurrency, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(MigrationStatus) },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MigrateAccountBalanceResponse {
    return new MigrateAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MigrateAccountBalanceResponse {
    return new MigrateAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MigrateAccountBalanceResponse {
    return new MigrateAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MigrateAccountBalanceResponse | PlainMessage<MigrateAccountBalanceResponse> | undefined, b: MigrateAccountBalanceResponse | PlainMessage<MigrateAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(MigrateAccountBalanceResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetBalanceMigrationOfferResponse
 */
export class GetBalanceMigrationOfferResponse extends Message<GetBalanceMigrationOfferResponse> {
  /**
   * The customer's Webinterface (legacy) balance, set only when they may move it
   * to Chargebee themselves with MigrateOwnAccountBalance and it would then pay
   * for the order in full (TV-2188). Unset for everybody else — a migrated
   * customer, an excluded one, a balance that falls short, a currency that does
   * not fit their country, or a ledger the migration would refuse — so its
   * presence is the whole offer.
   *
   * @generated from field: gportal.type.v1.Money offer = 1;
   */
  offer?: Money;

  constructor(data?: PartialMessage<GetBalanceMigrationOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetBalanceMigrationOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBalanceMigrationOfferResponse {
    return new GetBalanceMigrationOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBalanceMigrationOfferResponse {
    return new GetBalanceMigrationOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBalanceMigrationOfferResponse {
    return new GetBalanceMigrationOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBalanceMigrationOfferResponse | PlainMessage<GetBalanceMigrationOfferResponse> | undefined, b: GetBalanceMigrationOfferResponse | PlainMessage<GetBalanceMigrationOfferResponse> | undefined): boolean {
    return proto3.util.equals(GetBalanceMigrationOfferResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.MigrateOwnAccountBalanceResponse
 */
export class MigrateOwnAccountBalanceResponse extends Message<MigrateOwnAccountBalanceResponse> {
  /**
   * What the migration did. MIGRATED, ALREADY_MIGRATED and RESUMED mean the
   * balance is on Chargebee now. FAILED_NEEDS_RETRY means the move did not
   * finish and repeating the call is safe — the one-way flag may already be
   * set. Every SKIPPED_ value means nothing moved and the customer stays on the
   * legacy ledger. Deliberately no reason string: the support RPC's reasons are
   * written for supporters, not customers.
   *
   * @generated from field: gportal.api.payment.v1.MigrationStatus status = 1;
   */
  status = MigrationStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<MigrateOwnAccountBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.MigrateOwnAccountBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(MigrationStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MigrateOwnAccountBalanceResponse {
    return new MigrateOwnAccountBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MigrateOwnAccountBalanceResponse {
    return new MigrateOwnAccountBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MigrateOwnAccountBalanceResponse {
    return new MigrateOwnAccountBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MigrateOwnAccountBalanceResponse | PlainMessage<MigrateOwnAccountBalanceResponse> | undefined, b: MigrateOwnAccountBalanceResponse | PlainMessage<MigrateOwnAccountBalanceResponse> | undefined): boolean {
    return proto3.util.equals(MigrateOwnAccountBalanceResponse, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.StartNewCustomerMigrationResponse
 */
export class StartNewCustomerMigrationResponse extends Message<StartNewCustomerMigrationResponse> {
  /**
   * True when the migration was queued. False when it does not apply to this
   * customer here: switched off for this region, or a customer this
   * environment does not own. Whether a queued customer is then migrated is
   * decided when the work runs.
   *
   * @generated from field: bool queued = 1;
   */
  queued = false;

  constructor(data?: PartialMessage<StartNewCustomerMigrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.StartNewCustomerMigrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "queued", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartNewCustomerMigrationResponse {
    return new StartNewCustomerMigrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartNewCustomerMigrationResponse {
    return new StartNewCustomerMigrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartNewCustomerMigrationResponse {
    return new StartNewCustomerMigrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartNewCustomerMigrationResponse | PlainMessage<StartNewCustomerMigrationResponse> | undefined, b: StartNewCustomerMigrationResponse | PlainMessage<StartNewCustomerMigrationResponse> | undefined): boolean {
    return proto3.util.equals(StartNewCustomerMigrationResponse, a, b);
  }
}

/**
 * One consume this side has applied — the money left the customer's Chargebee
 * balance and an invoice stands for it.
 *
 * Everything a caller needs either to re-drive the work the charge paid for or
 * to reverse it is here, because the caller may be looking at this hours after
 * the request that produced it died.
 *
 * @generated from message gportal.api.payment.v1.AppliedBalanceOperation
 */
export class AppliedBalanceOperation extends Message<AppliedBalanceOperation> {
  /**
   * The idempotency key the operation was claimed under, e.g.
   * `consume:basket:<uuid>` or `consume:<order id>:<interval id>`. This is what
   * a caller matches against its own ledger, and what it would replay under.
   *
   * @generated from field: string reference = 1;
   */
  reference = "";

  /**
   * The Webinterface `users`.`id` the operation was booked for. NOT
   * `customer_details`.`id` — the reference is built from that one, and the two
   * are different numbers for the same person.
   *
   * @generated from field: uint64 customer_id = 2;
   */
  customerId = protoInt64.zero;

  /**
   * The Keycloak account, so a caller that works in those can avoid a lookup.
   *
   * @generated from field: string customer_keycloak_id = 3;
   */
  customerKeycloakId = "";

  /**
   * The Chargebee customer the money came off, `<keycloak id>_<EUR|INT>`.
   *
   * @generated from field: string chargebee_customer_id = 4;
   */
  chargebeeCustomerId = "";

  /**
   * @generated from field: gportal.type.v1.Money amount = 5;
   */
  amount?: Money;

  /**
   * The invoice the charge raised. This is the evidence the customer paid, and
   * the handle a reversal credits against.
   *
   * @generated from field: string chargebee_invoice_id = 6;
   */
  chargebeeInvoiceId = "";

  /**
   * When the operation reached `applied`, i.e. when the money actually moved.
   *
   * @generated from field: google.protobuf.Timestamp applied_at = 7;
   */
  appliedAt?: Timestamp;

  /**
   * How many attempts it took. Greater than one means an earlier attempt failed
   * or was reclaimed, which is the shape a caller is most likely to find
   * unsettled — the attempt that charged is often not the one that returned.
   *
   * @generated from field: uint32 attempts = 8;
   */
  attempts = 0;

  /**
   * Whatever the caller sent as `recovery_payload` on the spend, verbatim.
   *
   * Empty means the spend cannot be repaired and can only be refunded — either
   * the caller sent nothing, or the request asked for it to be omitted. The
   * difference matters to a caller deciding between repairing and refunding,
   * which is why an empty payload is never silently treated as "no payload
   * exists".
   *
   * @generated from field: bytes recovery_payload = 9;
   */
  recoveryPayload = new Uint8Array(0);

  constructor(data?: PartialMessage<AppliedBalanceOperation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.AppliedBalanceOperation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "customer_keycloak_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chargebee_customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "amount", kind: "message", T: Money },
    { no: 6, name: "chargebee_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "applied_at", kind: "message", T: Timestamp },
    { no: 8, name: "attempts", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "recovery_payload", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AppliedBalanceOperation {
    return new AppliedBalanceOperation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AppliedBalanceOperation {
    return new AppliedBalanceOperation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AppliedBalanceOperation {
    return new AppliedBalanceOperation().fromJsonString(jsonString, options);
  }

  static equals(a: AppliedBalanceOperation | PlainMessage<AppliedBalanceOperation> | undefined, b: AppliedBalanceOperation | PlainMessage<AppliedBalanceOperation> | undefined): boolean {
    return proto3.util.equals(AppliedBalanceOperation, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.ListAppliedBalanceOperationsResponse
 */
export class ListAppliedBalanceOperationsResponse extends Message<ListAppliedBalanceOperationsResponse> {
  /**
   * Oldest first, so a caller that hits `limit` can page by moving
   * `applied_since` to the last entry it saw.
   *
   * @generated from field: repeated gportal.api.payment.v1.AppliedBalanceOperation operations = 1;
   */
  operations: AppliedBalanceOperation[] = [];

  /**
   * True when `limit` cut the result short and another page exists.
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore = false;

  constructor(data?: PartialMessage<ListAppliedBalanceOperationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListAppliedBalanceOperationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "operations", kind: "message", T: AppliedBalanceOperation, repeated: true },
    { no: 2, name: "has_more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAppliedBalanceOperationsResponse {
    return new ListAppliedBalanceOperationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAppliedBalanceOperationsResponse {
    return new ListAppliedBalanceOperationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAppliedBalanceOperationsResponse {
    return new ListAppliedBalanceOperationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAppliedBalanceOperationsResponse | PlainMessage<ListAppliedBalanceOperationsResponse> | undefined, b: ListAppliedBalanceOperationsResponse | PlainMessage<ListAppliedBalanceOperationsResponse> | undefined): boolean {
    return proto3.util.equals(ListAppliedBalanceOperationsResponse, a, b);
  }
}

/**
 * One row of the customer's money history.
 *
 * @generated from message gportal.api.payment.v1.LedgerTransaction
 */
export class LedgerTransaction extends Message<LedgerTransaction> {
  /**
   * A string rather than the Webinterface's integer, so a Chargebee `txn_...`
   * fits the same field when the merged list arrives.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gportal.api.payment.v1.PaymentRecordSource source = 2;
   */
  source = PaymentRecordSource.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * UNSPECIFIED rather than absent for a row with no type — see the enum.
   *
   * @generated from field: gportal.api.payment.v1.LedgerTransactionType type = 4;
   */
  type = LedgerTransactionType.UNSPECIFIED;

  /**
   * What the customer is shown to explain the row. Free text written by support
   * and by the systems that book the row; not parseable, not a key.
   *
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * @generated from field: gportal.type.v1.Money amount = 6;
   */
  amount?: Money;

  /**
   * The running balance after this row, per currency — the Webinterface keeps one
   * series per (customer, currency), so it is only meaningful within a currency.
   * Absent where the trigger never filled it, and absent for any source that keeps
   * no running balance; a zero would read as a balance that settled to nothing.
   *
   * @generated from field: optional gportal.type.v1.Money balance_after = 7;
   */
  balanceAfter?: Money;

  constructor(data?: PartialMessage<LedgerTransaction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.LedgerTransaction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source", kind: "enum", T: proto3.getEnumType(PaymentRecordSource) },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(LedgerTransactionType) },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount", kind: "message", T: Money },
    { no: 7, name: "balance_after", kind: "message", T: Money, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LedgerTransaction {
    return new LedgerTransaction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LedgerTransaction {
    return new LedgerTransaction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LedgerTransaction {
    return new LedgerTransaction().fromJsonString(jsonString, options);
  }

  static equals(a: LedgerTransaction | PlainMessage<LedgerTransaction> | undefined, b: LedgerTransaction | PlainMessage<LedgerTransaction> | undefined): boolean {
    return proto3.util.equals(LedgerTransaction, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.ListTransactionsResponse
 */
export class ListTransactionsResponse extends Message<ListTransactionsResponse> {
  /**
   * @generated from field: repeated gportal.api.payment.v1.LedgerTransaction transactions = 1;
   */
  transactions: LedgerTransaction[] = [];

  /**
   * @generated from field: gportal.type.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: int32 total_items = 3;
   */
  totalItems = 0;

  /**
   * Sources that did not answer. The page renders what loaded and says which half is
   * missing, rather than failing whole: Chargebee's rate limit is per site and shared
   * with checkout, so a throttled history read is a thing to degrade around, not an
   * outage. Same contract as ListSubscriptions.failed_sources.
   *
   * @generated from field: repeated gportal.api.payment.v1.PaymentRecordSource failed_sources = 4;
   */
  failedSources: PaymentRecordSource[] = [];

  /**
   * True when a source hit its own read bound, so the union is the newest rows and not
   * the whole history. `total_items` and `pagination` describe what can actually be
   * paged, so without this a customer with more history than the bound is told a
   * smaller number with nothing to say it is a ceiling.
   *
   * @generated from field: bool truncated = 5;
   */
  truncated = false;

  constructor(data?: PartialMessage<ListTransactionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListTransactionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transactions", kind: "message", T: LedgerTransaction, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 3, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "failed_sources", kind: "enum", T: proto3.getEnumType(PaymentRecordSource), repeated: true },
    { no: 5, name: "truncated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTransactionsResponse | PlainMessage<ListTransactionsResponse> | undefined, b: ListTransactionsResponse | PlainMessage<ListTransactionsResponse> | undefined): boolean {
    return proto3.util.equals(ListTransactionsResponse, a, b);
  }
}

/**
 * One invoice, or one billing period that could become one.
 *
 * @generated from message gportal.api.payment.v1.Invoice
 */
export class Invoice extends Message<Invoice> {
  /**
   * `GP<interval id><EUR|INT>` for a legacy invoice. A string for the same reason
   * LedgerTransaction.id is.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gportal.api.payment.v1.PaymentRecordSource source = 2;
   */
  source = PaymentRecordSource.UNSPECIFIED;

  /**
   * The legacy order the billing period belongs to. Absent for a source whose
   * invoices are not per-order.
   *
   * @generated from field: optional int64 order_id = 3;
   */
  orderId?: bigint;

  /**
   * The product the period was billed for, as the customer knows it.
   *
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * @generated from field: gportal.type.v1.Money amount = 5;
   */
  amount?: Money;

  /**
   * @generated from field: google.protobuf.Timestamp period_start = 6;
   */
  periodStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp period_stop = 7;
   */
  periodStop?: Timestamp;

  /**
   * Whether a document can be had right now.
   *
   * @generated from field: bool is_available = 8;
   */
  isAvailable = false;

  /**
   * Why not, when it cannot: `period-not-ended`, `address-is-incomplete` or
   * `issued-in-billing-portal`. A stable key, not a sentence — the caller holds the
   * translations. Empty exactly when is_available is true.
   *
   * @generated from field: string reason_not_available = 9;
   */
  reasonNotAvailable = "";

  /**
   * Whether the document already exists. Legacy invoices are minted on demand, so
   * this is false for most periods and says nothing about whether one may be.
   *
   * @generated from field: bool is_generated = 10;
   */
  isGenerated = false;

  constructor(data?: PartialMessage<Invoice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.Invoice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source", kind: "enum", T: proto3.getEnumType(PaymentRecordSource) },
    { no: 3, name: "order_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "amount", kind: "message", T: Money },
    { no: 6, name: "period_start", kind: "message", T: Timestamp },
    { no: 7, name: "period_stop", kind: "message", T: Timestamp },
    { no: 8, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "reason_not_available", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "is_generated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Invoice {
    return new Invoice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Invoice {
    return new Invoice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Invoice {
    return new Invoice().fromJsonString(jsonString, options);
  }

  static equals(a: Invoice | PlainMessage<Invoice> | undefined, b: Invoice | PlainMessage<Invoice> | undefined): boolean {
    return proto3.util.equals(Invoice, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.ListInvoicesResponse
 */
export class ListInvoicesResponse extends Message<ListInvoicesResponse> {
  /**
   * @generated from field: repeated gportal.api.payment.v1.Invoice invoices = 1;
   */
  invoices: Invoice[] = [];

  /**
   * @generated from field: gportal.type.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: int32 total_items = 3;
   */
  totalItems = 0;

  /**
   * See ListTransactionsResponse.failed_sources.
   *
   * @generated from field: repeated gportal.api.payment.v1.PaymentRecordSource failed_sources = 4;
   */
  failedSources: PaymentRecordSource[] = [];

  /**
   * True when a source hit its own read bound, so the union is the newest rows and not
   * the whole history. `total_items` and `pagination` describe what can actually be
   * paged, so without this a customer with more history than the bound is told a
   * smaller number with nothing to say it is a ceiling.
   *
   * @generated from field: bool truncated = 5;
   */
  truncated = false;

  constructor(data?: PartialMessage<ListInvoicesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.ListInvoicesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invoices", kind: "message", T: Invoice, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 3, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "failed_sources", kind: "enum", T: proto3.getEnumType(PaymentRecordSource), repeated: true },
    { no: 5, name: "truncated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListInvoicesResponse {
    return new ListInvoicesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListInvoicesResponse {
    return new ListInvoicesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListInvoicesResponse {
    return new ListInvoicesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListInvoicesResponse | PlainMessage<ListInvoicesResponse> | undefined, b: ListInvoicesResponse | PlainMessage<ListInvoicesResponse> | undefined): boolean {
    return proto3.util.equals(ListInvoicesResponse, a, b);
  }
}

/**
 * The address a legacy invoice is made out to.
 *
 * @generated from message gportal.api.payment.v1.BillingAddress
 */
export class BillingAddress extends Message<BillingAddress> {
  /**
   * @generated from field: string forename = 1;
   */
  forename = "";

  /**
   * @generated from field: string surname = 2;
   */
  surname = "";

  /**
   * @generated from field: string street = 3;
   */
  street = "";

  /**
   * @generated from field: string zipcode = 4;
   */
  zipcode = "";

  /**
   * @generated from field: string location = 5;
   */
  location = "";

  /**
   * @generated from field: optional int32 country_id = 6;
   */
  countryId?: number;

  /**
   * @generated from field: optional string country_label = 7;
   */
  countryLabel?: string;

  /**
   * Whether the address can carry an invoice. Served rather than left to the caller
   * to infer from the fields above: it is the same predicate Invoice.is_available
   * uses, and a second copy of it decides whether a customer can obtain an invoice
   * at all.
   *
   * @generated from field: bool is_complete = 8;
   */
  isComplete = false;

  constructor(data?: PartialMessage<BillingAddress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.BillingAddress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "forename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "surname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "street", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "zipcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "country_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "country_label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "is_complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingAddress {
    return new BillingAddress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingAddress {
    return new BillingAddress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingAddress {
    return new BillingAddress().fromJsonString(jsonString, options);
  }

  static equals(a: BillingAddress | PlainMessage<BillingAddress> | undefined, b: BillingAddress | PlainMessage<BillingAddress> | undefined): boolean {
    return proto3.util.equals(BillingAddress, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.Country
 */
export class Country extends Message<Country> {
  /**
   * @generated from field: int32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  constructor(data?: PartialMessage<Country>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.Country";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Country {
    return new Country().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Country {
    return new Country().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Country {
    return new Country().fromJsonString(jsonString, options);
  }

  static equals(a: Country | PlainMessage<Country> | undefined, b: Country | PlainMessage<Country> | undefined): boolean {
    return proto3.util.equals(Country, a, b);
  }
}

/**
 * @generated from message gportal.api.payment.v1.GetBillingAddressResponse
 */
export class GetBillingAddressResponse extends Message<GetBillingAddressResponse> {
  /**
   * @generated from field: gportal.api.payment.v1.BillingAddress address = 1;
   */
  address?: BillingAddress;

  /**
   * The countries an address may name. Already filtered — the sanctioned ones are
   * not offered.
   *
   * @generated from field: repeated gportal.api.payment.v1.Country countries = 2;
   */
  countries: Country[] = [];

  constructor(data?: PartialMessage<GetBillingAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.payment.v1.GetBillingAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "message", T: BillingAddress },
    { no: 2, name: "countries", kind: "message", T: Country, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingAddressResponse {
    return new GetBillingAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingAddressResponse {
    return new GetBillingAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingAddressResponse {
    return new GetBillingAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingAddressResponse | PlainMessage<GetBillingAddressResponse> | undefined, b: GetBillingAddressResponse | PlainMessage<GetBillingAddressResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingAddressResponse, a, b);
  }
}

